import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiContractService extends ApiBaseService {

  protected headers: Headers;
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }
  /**
   * @param params 
   * @return void
   */
  get(): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/contract',
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * 有料プラン申し込み用のAPI
   * 
   * POST: /api/v1/contract/apply/plan 
   * 
   * ```
   * {
   *    "paymentPlan":{"code":"P02", "name":"月払い"},
   *    "paymentMethod":{"code":"PP01", "name":"銀行振込"}
   * }
   * ```
   * 
   * @param params 
   */
  applyPlan(params): Promise<any> {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/contract/apply/plan',
        body: params,
        headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  
  /**
   * 契約の自動更新設定
   * 
   * POST: /api/v1/contract/request/renewal
   * ```
   * {
   *    "isAutoContractRenewal": true
   * } 
   * ```
   */
  changeAutoContractRenewal(params): Promise<any> {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/contract/request/renewal',
        body: params,
        headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  paymentHistory(): Promise<any> {
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/contract/payment/history',
        body: {}, headers: this.headers}
      ).subscribe(response => resolve(response))
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-contract.service.ts